import React, { useRef } from 'react';
import { ChargingRange, CHARGE_TYPE_FIXED } from '../api/charging/data';
import ChargingRangeForm from '../components/ChargingRangeForm';
import useUXStore from '../api/ux/store';

const useChargingRangeModal = () => {
    const { refreshDialog, hideDialog } = useUXStore();
    const rangeRef = useRef<ChargingRange>({
        id: '',
        minAmount: 0,
        maxAmount: 0,
        charge: 0,
        chargeType: CHARGE_TYPE_FIXED
    });

    const showAddDialog = (onConfirm: (range: ChargingRange) => void) => {
        rangeRef.current = {
            id: `range-${Date.now()}`,
            minAmount: 0,
            maxAmount: 0,
            charge: 0,
            chargeType: CHARGE_TYPE_FIXED
        };

        refreshDialog({
            id: 'add-charging-range',
            title: 'Add Charging Range',
            visible: true,
            content: (
                <ChargingRangeForm 
                    initialRange={rangeRef.current}
                    onRangeChange={(range) => {
                        rangeRef.current = range;
                    }}
                />
            ),
            confirmContent: 'Add Range',
            confirmActive: true,
            onConfirm: () => {
                onConfirm(rangeRef.current);
            },
            onClose: () => hideDialog('add-charging-range')
        }, true);
    };

    const showEditDialog = (initialRange: ChargingRange, onConfirm: (range: ChargingRange) => void) => {
        rangeRef.current = { ...initialRange };

        refreshDialog({
            id: 'edit-charging-range',
            title: 'Edit Charging Range',
            visible: true,
            content: (
                <ChargingRangeForm 
                    initialRange={rangeRef.current}
                    onRangeChange={(range) => {
                        rangeRef.current = range;
                    }}
                />
            ),
            confirmContent: 'Update Range',
            confirmActive: true,
            onConfirm: () => {
                onConfirm(rangeRef.current);
            },
            onClose: () => hideDialog('edit-charging-range')
        }, true);
    };

    return { showAddDialog, showEditDialog };
};

export default useChargingRangeModal;